import { render, staticRenderFns } from "./ServiceInfoDetail.vue?vue&type=template&id=0e308769&scoped=true"
import script from "./ServiceInfoDetail.vue?vue&type=script&lang=js"
export * from "./ServiceInfoDetail.vue?vue&type=script&lang=js"
import style0 from "./ServiceInfoDetail.vue?vue&type=style&index=0&id=0e308769&prod&lang=stylus"
import style1 from "./ServiceInfoDetail.vue?vue&type=style&index=1&id=0e308769&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e308769",
  null
  
)

export default component.exports